import { atom } from 'recoil'

export default atom({
  key: 'mapSource',
  default: [],
})
